// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2yI8d","content":"GlobalSearch_content__hRsPm"};